import React from "react";

const ArrowIcon = () => {
  return (
    <div>
      <svg
        width="22"
        height="26"
        viewBox="0 0 22 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_8_451)">
          <path
            d="M18.1733 14.0776C18.3406 13.9102 18.4243 13.7009 18.4243 13.4498C18.4243 13.1987 18.3406 12.9894 18.1733 12.822L16.9043 11.5525L11.8565 6.50223C11.6891 6.33482 11.48 6.25112 11.229 6.25112C10.978 6.25112 10.7688 6.33482 10.6015 6.50223L9.33253 7.77176C9.1652 7.93917 9.08154 8.14844 9.08154 8.39955C9.08154 8.65067 9.1652 8.85993 9.33253 9.02734L11.968 11.6641H4.96794C4.72624 11.6641 4.51707 11.7524 4.34044 11.9291C4.16381 12.1058 4.0755 12.3151 4.0755 12.5569V14.3426C4.0755 14.5844 4.16381 14.7937 4.34044 14.9704C4.51707 15.1471 4.72624 15.2355 4.96794 15.2355H11.968L9.33253 17.8722C9.1559 18.0489 9.06759 18.2582 9.06759 18.5C9.06759 18.7418 9.1559 18.9511 9.33253 19.1278L10.6015 20.3973C10.7688 20.5647 10.978 20.6484 11.229 20.6484C11.48 20.6484 11.6891 20.5647 11.8565 20.3973L16.9043 15.3471L18.1733 14.0776ZM20.488 8.07171C20.488 8.07171 20.7274 8.4821 21.2062 9.30287C21.6849 10.1237 21.9243 11.506 21.9243 13.4498C21.9243 15.3936 21.4456 17.1863 20.488 18.8278C19.5305 20.4694 18.2314 21.7692 16.5906 22.7271C14.9498 23.6851 13.1579 24.1641 11.215 24.1641C9.27211 24.1641 7.48025 23.6851 5.83947 22.7271C4.19868 21.7692 2.89952 20.4694 1.94201 18.8278C0.984495 17.1863 0.505737 15.3936 0.505737 13.4498C0.505737 11.506 0.984495 9.71326 1.94201 8.07171C2.89952 6.43015 4.19868 5.13039 5.83947 4.17243C7.48025 3.21447 9.27211 2.73549 11.215 2.73549C13.1579 2.73549 14.9498 3.21447 16.5906 4.17243C18.2314 5.13039 19.5305 6.43015 20.488 8.07171Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_8_451">
            <rect
              width="21.43"
              height="25"
              fill="white"
              transform="matrix(1 0 0 -1 0.5 25.9502)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default ArrowIcon;
